/** @file keyup: updates modifiers and releases the key (always, even from an input, so nothing sticks). */
import type { KeySourceEvent } from '../keyTarget';
import { fireHolds } from './fireHolds';
import { keyState } from './keyState';
import { releaseAll } from './releaseAll';
import { updateModifiers } from './updateModifiers';

/** macOS sends no keyup for keys pressed while Meta is down, so releasing Meta releases everything held. */
export function handleKeyUp(event: KeySourceEvent): void {
  updateModifiers(event);
  if (event.code === 'MetaLeft' || event.code === 'MetaRight') releaseAll();
  else if (keyState.held.delete(event.code)) fireHolds(event.code, 'up');
}
